export default __webpack_public_path__ + "static/media/Elec15.4744ceab.png";